import { defineComponent as _defineComponent } from 'vue'
import BaseDialog from "@/components/base-dialog.vue";
import { ref } from "vue";
import useHttpRequest from "@/composables/use-http-request";
import {
  ExaminationSet,
  GetAllExaminationSetsDto,
} from "@/dtos/get-all-examination-sets.dto";
import store from "@/store";
import { useShowWarningMessage } from "@/composables/use-notifications";


export default /*#__PURE__*/_defineComponent({
  __name: 'examination-permits',
  props: {
    isVisible: { type: Boolean }
  },
  emits: ["close-dialog"],
  setup(__props: any, { emit }: { emit: ({
  (event: "close-dialog"): void;
}), expose: any, slots: any, attrs: any }) {





const loading = ref(false);
const isBusy = ref(false);
const loadingError = ref(false);
const examinationSets = ref<ExaminationSet[]>([]);
const examinationSetId = ref("");

const clearInputs = () => {
  examinationSets.value = [];
};

const onDialogClose = () => {
  emit("close-dialog");
};

const getAllExaminationPermits = async () => {
  const request = await useHttpRequest<GetAllExaminationSetsDto>({
    method: "GET",
    url: `students/examination-set-permits/${store.state.userId}`,
    loadingProperty: loading,
    errorLoadingProperty: loadingError,
  });
  if (!request) return;
  if (
    request.success &&
    request.message == "Examination sets fetched successfully"
  ) {
    examinationSets.value = request.examination_sets;
  }
};

const validateInput = () => {
  if (examinationSetId.value === "") {
    return useShowWarningMessage(
      "Exam set required",
      "Please select an exam set"
    );
  }
  return true;
};

const downloadStudentExamSetPermit = async () => {
  if (validateInput() !== true) {
    return;
  }
  const request = await useHttpRequest<{
    success: boolean;
    message: string;
    path_url: string;
  }>({
    method: "GET",
    url: `students/${store.state.userId}/examination-permits-for-examination-set/${examinationSetId.value}`,
    loadingProperty: null,
    showFullScreenLoader: true,
  });
  if (!request) return;
  if (
    request.success &&
    request.message == "Student examination permit downloaded successfully"
  ) {
    const link = document.createElement("a");
    link.href = request.path_url;
    link.download = "Student Exam Set Permit";
    link.click();
    onDialogClose();
    clearInputs();
  }
};

return { __sfc: true,emit, loading, isBusy, loadingError, examinationSets, examinationSetId, clearInputs, onDialogClose, getAllExaminationPermits, validateInput, downloadStudentExamSetPermit, BaseDialog }
}

})